import { addQuizEngagementMetric } from 'api/metrics'
import { useAuthContext } from 'components/context/AuthProvider'
import { useCallback } from 'react'
import { useMetric } from 'services/Metric'
import { IMetricScope, IMetricType, Quiz } from 'types'
import { formatMetricDate } from 'utils'

export function QuizMetric({ quiz }: { quiz: Quiz }) {
  const { user } = useAuthContext()

  const handleSaveMetric = useCallback(
    async (value: number, uuid: string, scope: IMetricScope) => {
      if (!user) {
        return
      }

      await addQuizEngagementMetric({
        userId: user.id,
        quizId: quiz.id,
        lessonId: quiz.lessonId,
        engagedFrom: formatMetricDate(value),
        engagedTo: formatMetricDate(),
        scope,
      })
    },
    [quiz, user],
  )

  useMetric({
    type: IMetricType.quiz,
    entityId: quiz.id,
    isImmediateStart: true,
    hasIdleTimer: true,
    idleLimitMin: 5,
    scope: IMetricScope.quiz,
    onSave: handleSaveMetric,
  })

  return null
}
